import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import colors from '@app/constants/colors';
import { calculateDiscount, calculatePrice } from '@app/helpers/promoRedemptionHelper';

const PromoRedemptionInfo = ({ option, promoCode }) => (
  <PromoInfoContainer>
    <PromoInfoRow>
      <span>
        <FormattedMessage id="promotion.fees" />
      </span>
      <span>
        {Number(get(option, 'priceWithoutVat', 0)).toFixed(2)}
        &nbsp;$
      </span>
    </PromoInfoRow>
    <PromoInfoRow>
      <span>
        <FormattedMessage id="promotion.discount" />
      </span>
      <span>
        {calculateDiscount(option)}
        &nbsp;$
      </span>
    </PromoInfoRow>
    <br />
    <PromoInfoRow>
      <span>
        <FormattedMessage id="promotion.total" />
      </span>
      <span>
        {calculatePrice(option)}
        &nbsp;$
      </span>
    </PromoInfoRow>
    <PromoCode>{promoCode}</PromoCode>
  </PromoInfoContainer>
);

PromoRedemptionInfo.propTypes = {
  promoCode: PropTypes.string.isRequired,
  option: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const mapStateToProps = ({
  subscribe: { availableOptions, promoCode },
}) => ({
  option: availableOptions[0] || [], promoCode,
});

export default connect(mapStateToProps, {})(PromoRedemptionInfo);

const PromoInfoContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const PromoInfoRow = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  & span {
    font-size: 18px;
  }
`;

const PromoCode = styled.p`
    font-size: 22px;
    color: ${colors.ALICE_BLUE};
    margin: 20px 0 5px;
    text-align: center;    
    width: 100%;
    border-radius: 10px;
    padding: 10px;
    background: none;
    border: 2px solid;
    border-color: ${colors.ALICE_BLUE};
    cursor: default;
    text-transform: none;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
`;
